#import "./ProductCardFragment.gql"

query ProductCardByHandleQuery($handle: String!, $lang: LanguageCode!) @inContext(language: $lang) {
  product: productByHandle(handle: $handle) {
    ...ProductCardFragment
  }
}
